export default __webpack_public_path__ + "static/media/hugo-bouthiette.820e47f1.jpg";